module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"file type not allowed":"This file type is not allowed."}}')
  delete Component.options._Ctor
}
